import { ApplicationFunctionBasicVO } from '../ApplicationFunctionBasicVO'

/**
 * スコープ値オブジェクト
 */
export type ScopeVO = {
  uuid: string
  code: string
  name: string
  scopeType: string
  operation: Operation
  dataType?: string
  applicationFunction?: ApplicationFunctionBasicVO
}

export enum Operation {
  LIST = 'LIST',
  GET = 'GET',
  UPDATE = 'UPDATE',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  ALL = 'ALL',
}

/**
 * Operation のi18nキーを取得
 */
export const OperationI18nLabelKey: Record<Operation, string> = {
  [Operation.LIST]: 'scope.operation.list',
  [Operation.GET]: 'scope.operation.get',
  [Operation.UPDATE]: 'scope.operation.update',
  [Operation.CREATE]: 'scope.operation.create',
  [Operation.DELETE]: 'scope.operation.delete',
  [Operation.ALL]: 'scope.operation.all',
} as const
